import React from "react";
import flowchart from "./../Sections/images/careers-flowchart.png";

function CareersData() {
  return (
    <div id="careersdata">
      <div className="fourthheader">
        <div>LOOKING TO ENERGISE</div>
        <div>YOUR CAREER?</div>
      </div>
      <div className="careerscontent">
        <div className="careerscontent-left">
          <div className="careers-hiring">SEΠSE is Hiring!</div>
          <div className="careers-message">
            "For the strength of the Pack is the Wolf, and the strength of the
            Wolf is the Pack."; Be a part of the force, challenge yourself and
            grow with the pack. SEΠSE is exploring for candidates with brilliant
            technical skillsets in Web Application Development to elevate it's
            Engineering Department.
          </div>
        </div>
        <div className="careerscontent-right">
          <img
            src={flowchart}
            alt="careerflowchart"
            className="careers-flowchart"
          />
          <div className="careers-message-r">
            Advance, earn your spot in the team and develop along with Company.
            Write to us at
          </div>
          <div className="careers-email">careers@signzclub.com</div>
        </div>
      </div>
    </div>
  );
}

export default CareersData;
